import { useQueryParam, withDefault, NumberParam } from 'use-query-params';
import useCurrentUser from 'hooks/useCurrentUser';
import useAssignmentType from 'hooks/useAssignmentType';
import { combinedPayRateOptions } from '@mp';
interface IUseMinimumPayRate {
  payRateOptions: number[];
  minimumRate: number;
  setMinimumRate: (minimumRate: number | undefined) => void;
  clearMinimumRate: () => void;
  hasMinimumRate: boolean;
}

export const useMinimumPayRate = (): IUseMinimumPayRate => {
  const { currentUser } = useCurrentUser();
  const kinds = currentUser?.professional?.kinds ?? [];
  const assignmentType = useAssignmentType();

  const [minimum_rate, setQuery] = useQueryParam('minimum_rate', withDefault(NumberParam, 0));

  const clearMinimumRate = () => setQuery(undefined, 'replaceIn');
  const setMinimumRate = (minimumRate?: number) =>
    !!minimumRate ? setQuery(minimumRate, 'replaceIn') : clearMinimumRate();

  const options = combinedPayRateOptions({ kinds, assignmentType });

  const payRateOptions = [0, ...options];

  return {
    payRateOptions,
    minimumRate: minimum_rate,
    hasMinimumRate: !!minimum_rate,
    setMinimumRate,
    clearMinimumRate,
  };
};

export default useMinimumPayRate;
